import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { LoadingService } from '../services/loading.service';
import { SKIP_GLOBAL_LOADING } from '../http/skip-loading.context';

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingService = inject(LoadingService);

  // Skip loading indicator for certain requests
  if (
    req.context.get(SKIP_GLOBAL_LOADING) ||
    req.url.includes('/auth/refresh') ||
    req.url.includes('/superadmin/auth/') ||
    req.headers.has('X-Skip-Loading')
  ) {
    return next(req);
  }

  loadingService.show();

  return next(req).pipe(
    finalize(() => loadingService.hide())
  );
};

